import  api, { globalErrorHandler } from "../Api"

export const GET_MODULES = "GET_MODULES";
export const UPDATE_MODULE = "UPDATE_MODULE";
export const GET_MODULES_BYID = "GET_MODULES_BYID";
export const MOD_LOADING = "MOD_LOADING";
export const MOD_ERROR = "MOD_ERROR";

const config = {
  headers: {
      'content-type': 'application/json',
  }
};

export const GetModules = () => {
  
  return async dispatch => {
    dispatch({
      type: MOD_LOADING
    });
    await api.get(`/Module/GetAll/`,config).then(res => 
      dispatch({
        type: GET_MODULES,
        data: res.data
        })
      ).catch(globalErrorHandler); 
  };
};

export const UpdateModule = (payload) => {
  return async dispatch => {
      dispatch({
          type: MOD_LOADING
      });

      api.put(`/Module/Update`, 
      payload, config).then(res => {
          dispatch({
              type: UPDATE_MODULE,
              payload: res.data
          });
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: MOD_ERROR 
        })
      });
  };
};
